module.exports = ".align-left {\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: flex-start !important; }\n\n.align-center {\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important; }\n\n.align-right {\n  -webkit-box-align: end !important;\n      -ms-flex-align: end !important;\n          align-items: flex-end !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/cot-analysis-form/cot-analysis-form.component.scss
// module id = ./src/app/widgets/cot-analysis-form/cot-analysis-form.component.scss
// module chunks = main